import { breakpoints } from '@awazevr/design-system.utils.react'
import { Text } from '@awazevr/design-system.components.text'
import { ConditionalWrapper } from '@/components/ConditionalWrapper/ConditionalWrapper'
import styled from 'styled-components'

type AspectRatio = '16/9' | '5/3'
type ImageFocus = 'Top' | 'Bottom' | 'Center' | 'Left' | 'Right'
export interface ResponsiveImageProps {
  image: string
  description?: string
  captionText?: string
  tabletImage?: string
  mobileImage?: string
  aspectRatio?: AspectRatio
  imageFocus?: ImageFocus
  lazyLoading?: boolean
}

const Fígure = styled.figure`
  margin: inherit;
  width: inherit;
`
const Image = styled.img<{ aspectRatio: AspectRatio; imageFocus: ImageFocus }>`
  border-radius: 8px;
  aspect-ratio: ${(p) => p.aspectRatio};
  object-fit: cover;
  object-position: ${(p) => p.imageFocus?.toLowerCase()};
`

export const ResponsiveImage: React.FC<ResponsiveImageProps> = ({
  image,
  tabletImage,
  mobileImage,
  description,
  captionText,
  imageFocus = 'Top',
  lazyLoading,
  aspectRatio = '16/9',
}) => (
  <ConditionalWrapper condition={!!captionText} Wrapper={Fígure}>
    <picture>
      <source
        srcSet={mobileImage || image}
        media={`(max-width: ${breakpoints[0]}px)`}
      />
      <source
        srcSet={tabletImage || image}
        media={`(max-width: ${breakpoints[1]}px)`}
      />
      <Image
        aspectRatio={aspectRatio}
        imageFocus={imageFocus}
        src={image}
        alt={description}
        height="auto"
        width="100%"
        loading={lazyLoading ? 'lazy' : undefined}
      />
    </picture>
    {captionText && (
      <figcaption>
        <Text sizes={100}> {captionText}</Text>
      </figcaption>
    )}
  </ConditionalWrapper>
)
